import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import StoresList from './StoresList'

export default function Stores() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/stores" component={StoresList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}